<template>
	<div class="modal-overlay" @click.self="$emit('close')">
		<div class="modal">
			<button class="modal__close" @click="$emit('close')" aria-label="Fermer">✕</button>
			<h3 class="modal__title">Accès restreint</h3>
			<p class="modal__text">Vous ne pouvez pas télécharger ce fichier car son accès est restreint.</p>
			<p class="modal__text">Pour demander l'accès, contactez l'auteur à l'adresse suivante :</p>
			<p><a :href="`mailto:${email}`">{{ email }}</a></p>
			<div class="modal__actions">
				<button class="button button--primary" @click="$emit('close')">OK</button>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'RestrictedAccessPopup',
	props: {
		email: {
			type: String,
			default: 'contact@lecoinduprof.fr'
		}
	}
}
</script>

<style scoped>
.modal-overlay {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: rgba(0, 0, 0, 0.4);
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 10001;
}

.modal {
	position: relative;
	background: #fff;
	padding: 24px 24px 20px 24px;
	border-radius: 8px;
	max-width: 520px;
	width: 92%;
	box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
}

.modal__close {
	position: absolute;
	top: 10px;
	right: 10px;
	background: transparent;
	border: none;
	cursor: pointer;
	font-size: 18px;
}

.modal__title {
	margin: 0 0 12px 0;
	font-size: 22px;
	font-weight: 700;
}

.modal__text {
	margin: 8px 0;
	font-size: 14px;
}

.modal__actions {
	margin-top: 16px;
	display: flex;
	justify-content: flex-end;
}
</style>


